import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import { topics } from "@/mocks/resources";
import { getCategoryMeta } from "@/utils/content";

export default function TopicCollections() {
  return (
    <section aria-label="推荐专题合集" className="mt-12 md:mt-16">
      <SectionHeading
        title="专题合集"
        subtitle="按热点与季节性策划的资源集合，点击进入对应标签筛选结果"
        icon="ri-stack-line"
      />
      <div className="grid grid-cols-1 md:grid-cols-3 gap-3 md:gap-5">
        {topics.map((topic, index) => {
          const meta = getCategoryMeta(topic.category);
          const surface =
            index === 0
              ? "bg-primary-950 text-background-200"
              : index === 1
                ? "bg-accent-50 border border-accent-200"
                : "bg-secondary-50 border border-secondary-200";
          const titleColor = index === 0 ? "text-background-50" : "text-foreground-950";
          const descColor = index === 0 ? "text-background-300" : "text-foreground-600";
          return (
            <Link
              key={topic.id}
              to={`/category/${topic.category}?tag=${encodeURIComponent(topic.tag)}`}
              className={`group relative overflow-hidden rounded-lg p-5 md:p-6 cursor-pointer transition-transform hover:-translate-y-0.5 ${surface}`}
            >
              <span
                className={`absolute -right-4 -top-4 w-24 h-24 flex items-center justify-center ${
                  index === 0 ? "text-primary-800" : "text-background-200"
                }`}
              >
                <i className={`${topic.icon} text-6xl`} aria-hidden="true"></i>
              </span>
              <span className="relative z-10 block">
                <span
                  className={`chip ${
                    index === 0 ? "bg-accent-500 text-background-50" : "bg-background-50 text-foreground-600"
                  }`}
                >
                  {meta?.label} · {topic.tag}
                </span>
                <span className={`mt-3 block font-heading font-extrabold text-lg ${titleColor}`}>{topic.title}</span>
                <span className={`mt-1 block text-xs ${index === 0 ? "text-accent-300" : "text-foreground-500"}`}>
                  {topic.subtitle}
                </span>
                <span className={`mt-3 block text-xs md:text-sm leading-6 ${descColor}`}>{topic.description}</span>
                <span
                  className={`mt-4 inline-flex items-center gap-1 text-xs font-medium ${
                    index === 0 ? "text-accent-300" : "text-primary-600"
                  }`}
                >
                  浏览专题
                  <i className="ri-arrow-right-line group-hover:translate-x-0.5 transition-transform" aria-hidden="true"></i>
                </span>
              </span>
            </Link>
          );
        })}
      </div>
    </section>
  );
}